/* global history */
/* global location */
/* global window */

/* eslint no-restricted-globals: ["off"] */

import React, { useEffect, useState, useCallback, memo } from "react";
import { Bluetooth, Fullscreen, Pets } from "@mui/icons-material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PortraitIcon from "@mui/icons-material/Portrait";
import SettingsIcon from "@mui/icons-material/Settings";
import OpenWith from "@mui/icons-material/OpenWith";
import RefreshIcon from "@mui/icons-material/Refresh";
import MapIcon from "@mui/icons-material/Map";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import Switch from "@mui/material/Switch";
import {
  AppBar,
  Toolbar,
  styled,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Tooltip,
  Dialog,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { blue, grey, red, orange } from "@mui/material/colors";

const Icons = styled(Box)(({ theme }) => ({
  display: "none",
  gap: "20px",
  alignItems: "center",
  [theme.breakpoints.up("sm")]: {
    display: "flex",
  },
}));

const titlecontainer = {
  xs: "none",
  sm: "block",
  marginBottom: 0,
  fontWeight: "bold",
};

const titlebar = {
  paddingLeft: 10,
  paddingRight: 10,
  backgroundColor: red[800],
  border: "1px solid",
  borderRadius: "10px",
  fontWeight: "bold",
  lineHeight: "0.7",
};

const dsdetail = {
  marginTop: "-1.5px",
  lineHeight: "0.7",
  letterSpacing: "-0.5px",
};

const iconitem = {
  color: "white",
  width: 30,
  height: 30,
};

const switchstyle = {
  backgroundColor: grey[200],
  borderRadius: 3,
};

const UserBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "1px",
  alignItems: "center",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
});

const styles = {
  appBar: (ingox) => ({
    backgroundColor: ingox === "1" ? orange[900] : grey[500],
  }),
  titleContainer: {
    ...titlecontainer,
    fontFamily: "'Noto Sans KR', sans-serif",
  },
  icon: {
    ...iconitem,
    transition: "transform 0.2s",
  },
};

export const Navbar = memo((props) => {
  let tstring,
    ingox = "";
  const selectedDS = props.onStatus;
  const [open, setOpen] = useState(false);
  const [viewOX, setViewOX] = useState(false);
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const callRDVlist = useCallback(() => {
    props.onShowDS();
    sessionStorage.modalSort = "RDV";
  }, [props]);

  const callQRmgr = useCallback(() => {
    props.onShowDS();
    sessionStorage.modalSort = "QR";
  }, [props]);

  const callHelp = useCallback(() => {
    setOpen(false);
    setHelpModalOpen(true);
  }, []);

  const goActivityTypesConfig = useCallback(() => {
    setOpen(false);
    if (typeof props.onOpenActivityTypesConfig === "function") props.onOpenActivityTypesConfig();
  }, [props.onOpenActivityTypesConfig]);

  const MENU_ITEMS = [
    { id: "activityTypes", label: "실적관리 설정", handler: goActivityTypesConfig },
    { id: "qr", label: "QR코드관리", handler: callQRmgr },
    { id: "rdv", label: "자원집결지관리", handler: callRDVlist },
    { id: "help", label: "도움말", handler: callHelp },
    { id: "logout", label: "Logout", handler: () => location.reload() },
  ];

  useEffect(() => {
    console.log("Navbar: ", props.onStatus);
  }, [props.onStatus]);

  if (selectedDS != "") {
    tstring = `${sessionStorage.onname}/${sessionStorage.onipdt}/${sessionStorage.onaddr}`;
    ingox = sessionStorage.oningox;
  }

  const FullscreenOX = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };

  const viewOXHandler = (e) => {
    const ox = e && e.target && typeof e.target.checked === "boolean" ? e.target.checked : viewOX;
    sessionStorage.fullswitch = ox;
    if (typeof props.fullswitch === "function") props.fullswitch(ox);
    setViewOX(ox);
  };

  useEffect(() => {
    const sw = document.getElementById("fsw");
    if (sw && typeof sw.click === "function") {
      const timer = setTimeout(() => sw.click(), 0);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <AppBar position="sticky" style={styles.appBar(ingox)}>
      <StyledToolbar>
        <Box>
          <Typography variant="h4" sx={styles.titleContainer}>
            <span>동원자원관리시스템</span>
          </Typography>
          {selectedDS != "" ? (
            <Typography variant="h7" sx={dsdetail}>
              {tstring}
            </Typography>
          ) : null}
        </Box>
        <Pets sx={{ display: { xs: "block", sm: "none" } }} />
        <Icons>
          {selectedDS !== "" && (
            <Tooltip title="대시보드">
              <DashboardIcon
                sx={styles.icon}
                onClick={() => typeof props.onOpenDashboard === "function" && props.onOpenDashboard()}
              />
            </Tooltip>
          )}
          {props.viewmaptool && (
            <>
              <Tooltip title="위치정보 갱신">
                <RefreshIcon sx={styles.icon} onClick={() => window.dispatchEvent(new CustomEvent("mapRefresh"))} />
              </Tooltip>
              <Tooltip title="지도">
                <MapIcon sx={styles.icon} onClick={() => window.dispatchEvent(new CustomEvent("mapType", { detail: "roadmap" }))} />
              </Tooltip>
              <Tooltip title="위성">
                <SatelliteAltIcon sx={styles.icon} onClick={() => window.dispatchEvent(new CustomEvent("mapType", { detail: "hybrid" }))} />
              </Tooltip>
            </>
          )}
          <Tooltip title="전체 보기/숨기기">
            <Switch
              checked={viewOX}
              onChange={viewOXHandler}
              sx={switchstyle}
              size="small"
              id="fsw"
            />
          </Tooltip>
          <Tooltip title="전체화면">
            <OpenWith sx={styles.icon} onClick={FullscreenOX} />
          </Tooltip>
          <Tooltip title="설정">
            <SettingsIcon sx={styles.icon} onClick={() => setOpen(true)} />
          </Tooltip>
        </Icons>
      </StyledToolbar>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        open={open}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {MENU_ITEMS.map((item) => (
          <MenuItem key={item.id} onClick={item.handler}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* 도움말 모달: modal-top-position 규칙 적용, 외부 도움말 페이지 표시 */}
      <Dialog
        open={helpModalOpen}
        onClose={() => setHelpModalOpen(false)}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "hidden",
            maxWidth: 1100,
            position: "fixed",
            top: "10vh",
            left: "50%",
            transform: "translateX(-50%)",
            margin: 0,
            maxHeight: "80vh",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 1.5, py: 1, borderBottom: "1px solid", borderColor: "divider", backgroundColor: grey[100] }}>
          <Typography variant="h6" component="span" sx={{ fontWeight: "bold" }}>
            도움말
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Tooltip title="새 창에서 열기">
              <IconButton
                size="small"
                onClick={() => window.open("https://map.119survey.org/api/help.html", "_blank", "noopener,noreferrer")}
                aria-label="새 창에서 열기"
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="닫기">
              <IconButton size="small" onClick={() => setHelpModalOpen(false)} aria-label="닫기">
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Box sx={{ width: "100%", height: "calc(80vh - 52px)", minHeight: 400 }}>
          <iframe
            title="도움말"
            src="https://map.119survey.org/api/help.html"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        </Box>
      </Dialog>
    </AppBar>
  );
});
